import { gql } from "@apollo/client";

export const SUBGRAPHS_QUERY = gql`
  query Subgraphs($projectId: ID!, $cluster: GraphCluster!) {
    subgraphs(projectId: $projectId, cluster: $cluster) {
      createdAt
      id
      identifier
      cluster
      name
      projectId
      requestCount
      indexingStatus {
        entityCount
        synced
        health
        chains {
          network
          chainHeadBlock {
            number
          }
          earliestBlock {
            number
          }
          latestBlock {
            number
          }
        }
      }
    }
  }
`;

export const SUBGRAPH_LOGS_QUERY = gql`
  query SubgraphIndexingLogs($level: String!, $cluster: GraphCluster!, $subgraphDeploymentId: ID!, $query: String) {
    subgraphIndexingLogs(
      level: $level
      cluster: $cluster
      subgraphDeploymentId: $subgraphDeploymentId
      query: $query
    ) {
      level
      text
      timestamp
    }
  }
`;

export const CREATE_SUBGRAPH_MUTATION = gql`
  mutation CreateSubgraph($identifier: String!, $name: String!, $projectId: ID!, $cluster: GraphCluster!) {
    createSubgraph(identifier: $identifier, name: $name, projectId: $projectId, cluster: $cluster) {
      projectId
      identifier
      cluster
    }
  }
`;

export const DELETE_SUBGRAPH_MUTATION = gql`
  mutation DeleteSubgraph($projectId: ID!, $subgraphId: ID!, $cluster: GraphCluster!) {
    deleteSubgraph(projectId: $projectId, subgraphId: $subgraphId, cluster: $cluster) {
      projectId
    }
  }
`;

export const SUBGRAPH_METRICS_QUERY = gql`
  query SubgraphMetrics($cluster: GraphCluster!, $subgraphId: ID!, $showLast: TimeRange, $interval: String) {
    subgraphMetrics(cluster: $cluster, subgraphId: $subgraphId, showLast: $showLast, interval: $interval) {
      count
      timestamp
    }
  }
`;

export const SUBGRAPH_ORIGIN_METRICS_QUERY = gql`
  query SubgraphMetricsByOrigin($cluster: GraphCluster!, $subgraphId: ID!, $showLast: TimeRange, $interval: String) {
    subgraphMetricsByOrigin(cluster: $cluster, subgraphId: $subgraphId, showLast: $showLast, interval: $interval) {
      data {
        count
        timestamp
      }
      group
      count
    }
  }
`;
